var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-grow-0 h-20 justify-center flex-col px-3"},[(_vm.event && _vm.event.market)?_c('market-outcomes',{attrs:{"market":_vm.event.market,"inverse":true,"event":_vm.event}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }